import { z } from 'zod';
import { TAG_DESCRIPTION_MAX, tagSchema } from './exif.js';
/**
 * Contrats de la GESTION DE LA TAXONOMIE (T5 lot B, XPHOTO-26).
 *
 * Taxonomie STRICTEMENT PLATE : pas de catégories, pas de hiérarchie parent/enfant,
 * pas de libellés multilingues — un seul libellé par tag, le tag EST le descripteur
 * (« Chat », « Ferme », « Famille »). Ces schémas sont la SOURCE UNIQUE front + back.
 *
 * - `taxonomyTagSchema`      : un tag + son nombre d'usages (photos qui le portent).
 * - `taxonomyListResultSchema` : la liste complète du vocabulaire d'une bibliothèque.
 * - `mergeTagsRequestSchema` : fusion de tags (sources → cible conservée).
 * - `mergeTagsResultSchema`  : résultat d'une fusion (cible + comptes réaffectés/supprimés).
 *
 * `usageCount` compte les LIAISONS VALIDÉES (`asset_tags.status = 'validated'`) —
 * cohérent avec la facette Tags de la galerie. `proposedCount` compte les liaisons
 * `proposed` (propositions IA en attente, T5 lot D) : un tag à `usageCount === 0 &&
 * proposedCount > 0` est un « candidat » (proposé par l'IA, jamais validé).
 */
/**
 * Un tag de la taxonomie enrichi de ses nombres d'usages (validés) et de propositions,
 * ainsi que de sa DESCRIPTION libre optionnelle (définition qui guide l'IA de tagging ;
 * `null` = aucune).
 */
export const taxonomyTagSchema = tagSchema.extend({
    description: z.string().max(TAG_DESCRIPTION_MAX).nullable(),
    usageCount: z.number().int().nonnegative(),
    proposedCount: z.number().int().nonnegative(),
});
/** Résultat de `GET /api/libraries/:id/taxonomy` : tout le vocabulaire (zéro-usage inclus). */
export const taxonomyListResultSchema = z.object({
    tags: z.array(taxonomyTagSchema),
});
/**
 * Corps de `POST /api/libraries/:id/tags/merge`. Fusionne un ou plusieurs tags SOURCES
 * dans un tag CIBLE : les photos des sources sont réaffectées à la cible, puis les tags
 * sources sont supprimés. La cible NE DOIT PAS figurer parmi les sources (garde route
 * → 400) ; tous les tags doivent appartenir à la bibliothèque (garde repo → 400/404).
 */
export const mergeTagsRequestSchema = z.object({
    sourceTagIds: z.array(z.uuid()).min(1),
    targetTagId: z.uuid(),
});
/**
 * Résultat d'une fusion : le tag CONSERVÉ (la cible), le nombre de liaisons d'assets
 * réaffectées à la cible (hors doublons déjà portés par la cible), et le nombre de tags
 * sources supprimés.
 */
export const mergeTagsResultSchema = z.object({
    tag: tagSchema,
    reassignedAssets: z.number().int().nonnegative(),
    deletedTags: z.number().int().nonnegative(),
});
//# sourceMappingURL=taxonomy.js.map